import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { SparkleIcon, TrashIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { ComboBox, IconButton, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import { findEventConfig, getMenuItems, getSections, getValueMenuItems, getValueSections } from './helpers'
import * as Styles from './styles'

const TriggerEvent = ({
  selectedEvent,
  selectedValues,
  selectedInputValue,
  onChangeEvent,
  onChangeValues,
  onChangeInputValue,
  onRemove,
  disabled,
  canRemove,
  disabledTriggers = [],
  errors = [],
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const sections = getSections(t)
  const menuItems = getMenuItems(t, disabledTriggers)

  const eventConfig = findEventConfig(selectedEvent)
  const valueMenuItems = getValueMenuItems(selectedEvent, t)
  const valueSections = getValueSections(selectedEvent, t)
  const inputError = errors.find(error => error.field === eventConfig?.inputOptions?.field)

  return (
    <Styles.Container>
      <Styles.TitleContainer>
        <Styles.TitleContent>
          <SparkleIcon size={24} color={theme.colors.accent.on} />
          <Text type="titleS">{t('Evento de envío')}</Text>
        </Styles.TitleContent>
        <div>
          <Tooltip title={t('Se requiere al menos un trigger')} disabled={canRemove}>
            <IconButton
              variant="text"
              icon={<TrashIcon size={24} color={theme.colors.outline.default} />}
              onClick={onRemove}
              disabled={disabled || !canRemove}
            />
          </Tooltip>
        </div>
      </Styles.TitleContainer>
      <Styles.EventInfoContainer>
        <ComboBox
          label={t('Evento')}
          fullWidth
          sections={sections}
          menuItems={menuItems}
          value={selectedEvent}
          handleChange={onChangeEvent}
          backgroundColor={theme.colors.background.secondary}
          disabled={disabled}
        />
        {eventConfig?.inputOptions && (
          <InputWithLabel
            label={t(eventConfig.inputOptions.label)}
            fullWidth
            type={eventConfig.inputOptions.type}
            value={selectedInputValue}
            onChange={onChangeInputValue}
            backgroundColor={theme.colors.background.secondary}
            disabled={disabled}
            error={!!inputError}
            helperText={inputError && t(inputError.message)}
          />
        )}
        {valueMenuItems && (
          <ComboBox
            label={t(eventConfig?.valueOptions?.label)}
            fullWidth
            multiple
            sections={valueSections}
            menuItems={valueMenuItems}
            value={selectedValues}
            handleChange={onChangeValues}
            backgroundColor={theme.colors.background.secondary}
            disabled={disabled}
          />
        )}
        {eventConfig && (
          <Styles.Description>
            <Text type="bodyMRegular" color={theme.colors.text.muted}>
              {t(eventConfig.description)}
            </Text>
          </Styles.Description>
        )}
      </Styles.EventInfoContainer>
    </Styles.Container>
  )
}

export default TriggerEvent
